export const REPORTING_FRESHNESS_COPY =
  'Yesterday’s data is updated by 12 PM ET daily.';
